import { WorkflowState } from "common-util-experience-client";
import { createWorkflowApi } from "../../api-helpers/CommonUtilsApiHelper";
import { CommonDropdown } from "./CommonDropdown";

export interface Props {
  label: string;
  type: string;
  onChange: (selection?: WorkflowState) => void;
  disabled: boolean;
  required: boolean;
  initialValue?: string | WorkflowState;
}

export const WorkflowStatusDropdown = ({ label, type, onChange, disabled, required, initialValue }: Props) => {
  const workflowApi = createWorkflowApi();

  const loadData = async (): Promise<WorkflowState[]> => {
    if (!type) {
      return [];
    }
    
    const response = await workflowApi.workflowControllerGetStatesForWorkflow(type);
    return response.data;
  };

  return (
    <CommonDropdown
      label={label}
      keyProvider={state => state.stateId}
      labelProvider={state => state.stateName}
      dataProvider={loadData}
      onChange={onChange}
      disabled={disabled}
      required={required}
      initialValue={initialValue}
      ></CommonDropdown>
  );
};
